export default "__VITE_ASSET__Co9910Hp__"